
<template>
  <div ref="tooltip_target">
    <b-link class="nav-link cx_global_menu_dropdown_item" :to="to" :class="{ active: isActive(selector) }" v-if="$api.perms.hasMenuPermission(perm) && to">
      <i v-if="icon != null" class="material-icons md valign">{{ icon }}</i>{{ $translate(caption) }}
    </b-link>
    <b-nav-item class="cx_global_menu_dropdown_item" v-if="$api.perms.hasMenuPermission(perm) == false && to" disabled>
      <i v-if="icon != null" class="material-icons md valign">{{ icon }}</i>{{ $translate(caption) }}
    </b-nav-item>
    <b-link  class="nav-link cx_global_menu_dropdown_item" v-if="to == null" @click="onClick">
      <i v-if="icon != null" class="material-icons md valign">{{ icon }}</i>{{ $translate(caption) }}
    </b-link>    
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GlobalMenuItem extends Vue {
  @Prop({ default: null }) public to!: string;
  @Prop() public caption!: string;
  @Prop() public selector!: string;
  @Prop() public icon?: string;
  @Prop({ default: null }) public perm: string;
  @Prop({default: null}) public tooltip: string;

  public isActive(path: string) {
    if (path === '/') {
      return this.$route.path === path;
    } else {
      return this.$route.path.startsWith(path);
    }
  }
  public onClick(){
      this.$emit("click");
  }
  public mounted() {
    if(this.tooltip) this.$nextTick(() => {
      if (this.$refs.tooltip_target == null) return;
      this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);
    });
  }
}
</script>
<style lang="scss">


.cx_global_menu_dropdown_item {
  min-width: 120px;
  height: 32px;
  white-space: nowrap;
  color:#212529 !important;
  padding:4px 24px !important;
  font-weight: 400;
  display: block;
  cursor: pointer;
  .cx_spmode & {
    text-align: center;
  }
  &:hover {
      background-color:#f8f9fa;
  }
  &:active {
      background-color: #e0e4e7;
  }
  .material-icons {
    color: #212529;
    font-size: 24px;
    padding-left: 1px;
    margin-right: 4px;
    transform: translate(0, -5px);
  }
}
</style>